/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, useEffect } from 'react'
import { inject, observer } from 'mobx-react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { Prospects as ProspectsStore } from '../../stores/prospects'
import Layout from '../../components/Dashboard/newLayout'
import Signatures from '../../components/Dashboard/Settings/Signatures'
import './styles.scss'

interface Props extends RouteComponentProps {
  prospects?: ProspectsStore
  setIsAuthenticated: (isAuthenticated: boolean) => void
}
const AdminSignature: FC<Props> = ({ setIsAuthenticated, prospects }) => {
  useEffect(() => {
    prospects?.getMasters()
  }, [])
  return (
    <Layout title="Signature" setIsAuthenticated={setIsAuthenticated}>
      <div className="main-container">
        <div className="admin-signature">
          <Signatures />
        </div>
      </div>
    </Layout>
  )
}

export default inject('prospects')(withRouter(observer(AdminSignature)))
